import { makeAutoObservable } from 'mobx';

export class NetworkStatus {
	online: boolean = true;

	constructor() {
		makeAutoObservable(this);

		window.addEventListener('online', () => {
			this.setOnline(true);
		});

		window.addEventListener('offline', () => {
			this.setOnline(false);
		});
	}

	setOnline(state: boolean) {
		this.online = state;
	}
}
